import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET
export const GET_GLOBAL_VARIABLES_SUCCESS = 'GET_GLOBAL_VARIABLES_SUCCESS'
export const GET_GLOBAL_VARIABLES_FAILURE = 'GET_GLOBAL_VARIABLES_FAILURE'

// -- CREATE
export const CREATE_GLOBAL_VARIABLE_SUCCESS = 'CREATE_GLOBAL_VARIABLE_SUCCESS'
export const CREATE_GLOBAL_VARIABLE_FAILURE = 'CREATE_GLOBAL_VARIABLE_FAILURE'

// -- UPDATE
export const UPDATE_GLOBAL_VARIABLE_SUCCESS = 'UPDATE_GLOBAL_VARIABLE_SUCCESS'
export const UPDATE_GLOBAL_VARIABLE_FAILURE = 'UPDATE_GLOBAL_VARIABLE_FAILURE'

// -- DELETE
export const DELETE_GLOBAL_VARIABLE_SUCCESS = 'DELETE_GLOBAL_VARIABLE_SUCCESS'
export const DELETE_GLOBAL_VARIABLE_FAILURE = 'DELETE_GLOBAL_VARIABLE_FAILURE'

// -- SELECT
export const SELECT_GLOBAL_VARIABLES = 'SELECT_GLOBAL_VARIABLES'

// ---------------------------------------------------------------------------

/**
 * GET the list of all global variables attributes.
 *
 * @returns {Promise<array<object>>}
 */
export const getGlobalVariables = () => async (dispatch) => {
  const path = apiPaths.GLOBAL_VARIABLE_LIST
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalVariablesActions.getGlobalVariables()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_GLOBAL_VARIABLES_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_GLOBAL_VARIABLES_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a new global variable attribute.
 *
 * @param {object} newVariable New variable attribute object to create
 * @returns {Promise<object>}
 */
export const createGlobalVariable = (newVariable) => async (dispatch) => {
  const path = apiPaths.GLOBAL_VARIABLE_CREATE
  const api = new Api(path)
  const result = await api.create(newVariable)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalVariablesActions.createGlobalVariable()', {
    path,
    newVariable,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_GLOBAL_VARIABLE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_GLOBAL_VARIABLE_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific global variable attribute based on its variable ID
 *
 * @param {object} newVariable Object to set instead of the previous one.
 * @param {uui} vid Variable ID to update
 * @returns {Promise<object>}
 */
export const updateGlobalVariable = (newVariable, vid) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_VARIABLE_UPDATE, { vid })
  const api = new Api(path)
  const result = await api.update(newVariable)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalVariablesActions.updateGlobalVariable()', {
    path,
    newVariable,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_GLOBAL_VARIABLE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_GLOBAL_VARIABLE_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific global variable attribute based on its variable ID.
 *
 * @param {uuid} vid Variable ID to delete.
 * @returns {Promise<uuid>}
 */
export const deleteGlobalVariable = (vid) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_VARIABLE_DELETE, { vid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalVariablesActions.deleteGlobalVariable()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_GLOBAL_VARIABLE_SUCCESS,
      data: vid
    })
  }
  return dispatch({
    type: DELETE_GLOBAL_VARIABLE_FAILURE,
    data: result.data
  })
}

/**
 * SELECT a list of global variable UUID.
 *
 * @param {array<uuid>} data Array of global variable UUID to select.
 * @returns {Promise<string>}
 */
export const selectListGlobalVariables = (data) => async (dispatch) => {
  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalVariablesActions.selectListGlobalVariables()', { data })
  return dispatch({
    type: SELECT_GLOBAL_VARIABLES,
    data
  })
}
